module.exports = __webpack_public_path__ + "static/media/mozilla.4186cb91.png";